import { BookOpen } from 'lucide-react';

const ProgramsSection = () => {
    return (
        <section className="bg-muted/20 border-t border-border">
            <div className="container mx-auto max-w-4xl px-6 pt-14 pb-12 text-center">
                <h2 className="text-xl font-semibold text-foreground mb-4">
                    Currently supporting
                </h2>
                <div className="inline-flex items-center gap-3 px-5 py-3 bg-background rounded-xl border border-border shadow-sm">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                        <BookOpen className="w-5 h-5 text-primary" />
                    </div>
                    <div className="text-left">
                        <div className="font-semibold text-foreground text-base">Digital SAT</div>
                        <div className="text-base text-muted-foreground">College Board</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProgramsSection;
